module.exports = __webpack_public_path__ + "static/media/cart-empty.475dbded.png";